import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import toastr from "toastr"

interface UseDeleteOrderMutationParams {
  deviceId: string
  onOrderDeleted?: () => void
  onError?: (error: any) => void
}

export const useDeleteOrderMutation = ({ 
  deviceId,
  onOrderDeleted,
  onError: customOnError 
}: UseDeleteOrderMutationParams) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (orderUuidToDelete: string) => {
      if (!deviceId) {
        throw new Error("Device ID is required for order deletion")
      }
      
      return axios.delete(
        `/api/registration/order/${orderUuidToDelete}/?uuid=${orderUuidToDelete}&device_id=${deviceId}`,
        {
          headers: {
            "X-GB-UID": deviceId,
          },
        }
      )
    },
    onSuccess: () => {
      // Invalidate order queries
      queryClient.invalidateQueries({ queryKey: ["order"] })
      
      // Call custom success handler if provided
      if (onOrderDeleted) {
        onOrderDeleted()
      }
    },
    onError: (error: any) => {
      const message = String(
        error.response?.data?.message || "Failed to delete order"
      )
      toastr.error(message, "Failed to delete order")
      console.error("Failed to delete order:", error)
      
      // Call custom error handler if provided
      if (customOnError) {
        customOnError(error)
      }
    },
  })
}